import { CommonModule } from '@angular/common';
import {
  Component,
  ChangeDetectionStrategy,
  Input,
  Output,
  EventEmitter,
} from '@angular/core';
import { RouterModule } from '@angular/router';
import { PhoneInfo } from '@app/akita/api/addresses/models/phone.model';
import { ContactDetails } from '@app/akita/api/checkout/models/payment-request-info.model';
import { SessionAddressModel } from '@app/akita/api/checkout/models/session-address.model';
import { AkitaScreenQuery } from '@app/akita/screen/state/screen.query';
import { ScreenSizeInfoState } from '@app/akita/screen/state/screen.store';
import { PencilWrite2IconComponent } from '@app/shared/components/icons/generated/pencil-write-2/pencil-write-2.component';
import { TranslocoModule, TranslocoService } from '@ngneat/transloco';
import { Observable } from 'rxjs';

@Component({
  selector: 'popsy-address-details-overview',
  templateUrl: './address-details-overview.template.html',
  styleUrls: ['./address-details-overview.style.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, RouterModule, TranslocoModule, PencilWrite2IconComponent],
})
export class AddressDetailsOverviewComponent {
  @Input() public address?: SessionAddressModel | null = null;
  @Input() public deliveryId?: string | null = null;
  @Input() public country?: string | null = null;
  @Input() public phoneNumber?: PhoneInfo | null = null;
  @Input() public contactDetails?: ContactDetails | null = null;
  @Input() public email?: string | null = null;
  @Input() public fullName?: string | null = null;
  @Input() public hideEdit: boolean | null = null;
  @Output() public readonly edit: EventEmitter<void>;

  public language: string;
  public lessThan$: Observable<ScreenSizeInfoState>;

  constructor(
    private readonly akitaScreenQuery: AkitaScreenQuery,
    private readonly tranlate: TranslocoService
  ) {
    this.edit = new EventEmitter();
    this.language = this.tranlate.getActiveLang();
    this.lessThan$ = this.akitaScreenQuery.selectLessThan();
  }

  public onEditButtonClick(): boolean {
    this.edit.next();
    return false;
  }
}
